import React from 'react';
import styled from "@emotion/styled";

const AnalyticsTooltip = ({ kicker, title, rows }) => {
  return (
    <TooltipSurface>
      <TooltipHeader>
        {kicker && <TooltipKicker>{kicker}</TooltipKicker>}
        <TooltipTitle>{title}</TooltipTitle>
      </TooltipHeader>
      <TooltipRows>
        {rows.map((row) => (
          <TooltipRow key={row.label}>
            <TooltipLabel>{row.label}</TooltipLabel>
            <TooltipValue>{row.value}</TooltipValue>
          </TooltipRow>
        ))}
      </TooltipRows>
    </TooltipSurface>
  )
}

const TooltipSurface = styled.div(({ theme }) => `
  width: 17rem;
  overflow: hidden;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.75rem;
  background: ${theme.palette.common.white};
  box-shadow: 0 0.85rem 1.9rem rgba(15, 23, 42, 0.16);
`)

const TooltipHeader = styled.div(({ theme }) => `
  padding: 0.78rem 0.9rem 0.68rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.grayBorderLight};
`)

const TooltipKicker = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04rem;
  line-height: 1.2;
  text-transform: uppercase;
`)

const TooltipTitle = styled.div(({ theme }) => `
  margin-top: 0.15rem;
  color: ${theme.palette.common.black};
  font-size: 1.04rem;
  font-weight: 900;
  line-height: 1.25;
`)

const TooltipRows = styled.div`
  display: grid;
  gap: 0.04rem;
  padding: 0.5rem 0.9rem 0.72rem;
`

const TooltipRow = styled.div(({ theme }) => `
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.82rem;
  align-items: baseline;
  padding: 0.44rem 0;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorderLight};

  &:last-of-type {
    border-bottom: 0;
  }
`)

const TooltipLabel = styled.span(({ theme }) => `
  min-width: 0;
  color: ${theme.palette.common.grayText};
  font-size: 0.8rem;
  font-weight: 800;
  line-height: 1.2;
`)

const TooltipValue = styled.span(({ theme }) => `
  display: inline-flex;
  align-items: baseline;
  gap: 0.12rem;
  color: ${theme.palette.common.black};
  font-size: 0.92rem;
  font-weight: 900;
  line-height: 1.2;
  text-align: right;
`)

export default AnalyticsTooltip
